export default __webpack_public_path__ + "static/media/ed-pastor-with-freedom-arena.cc5a1898.jpg";